<template>
  <div>
    <div class="bg" style="background-color:#E8E8E8"></div>
    <div class="u-hd" @click="closeModle">
        <div class="hd-bk" >
            <i class="icon iconback"></i>&nbsp;返回
        </div>
        <div class="hd-tl">订货单申请</div>
    </div>
    <!-- <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="options"
        @select="onSelect"
    /> -->
    <div style="height:44px"></div>
    <div style="display:flex;align-items: center;">
        <div style="padding:5px 10px;" :style="{color:form.state=='NOAUDIT'?'#FF8518':'#4935ae'}">
            <i class="icon icondanju" style="font-size:50px;"></i>
        </div>
        <div style="width:calc(100% - 90px);">
            <div class="add-ord-title">订货单申请&nbsp;<span style="font-size:12px">({{form.no?form.no:'00000000000'}})</span></div> 
            <div class="add-ord-desc" style="display:flex;padding-top:5px;align-items: center;">
                <div style="width:calc(100% - 100px)">
                    <template v-if="!$route.query.show">
                        <div class="search-lst-tag" @click="$refs.selectMerchantPick.open()" v-if="$store.state.supplierInfo.businessType=='0'">
                            <div class="lst-tag-vle" style="background: #486ad8;color:#FFF;padding:5px;border-radius: 20px;"> 
                                <div class="placeholder" v-if="!form.merchantId">点击选择组织机构</div>
                                <div v-else class="f-hidden-text">{{form.merchantName}}</div>
                            </div>
                        </div>   
                        <div v-else>{{$store.state.supplierInfo.merchantName}}</div> 
                    </template>
                    <span v-else>{{form.merchantName}}</span>
                </div>
                <div style="width:100px;text-align:right;color:#4c37b6">{{moment(form.operatorTime).format("YYYY-MM-DD")}}</div>
            </div>
        </div>
    </div>
    <div style="background:#fff;margin:0 13px;width:calc(100vw - 25px;);border-top-left-radius:5px;border-top-right-radius:5px;overflow:hidden">
        <div>
            <detali-table :isShow="isShow" :order="form" :details="details" bindchangeTable="changeState"></detali-table>
        </div>
    </div>
    <div  style="display:flex;margin:0px 13px;;background:#486ad8;color:#FFF;align-items:center;text-align:center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;" v-if="!$route.query.show">
        <div style="flex:4;height: 50px;box-sizing: border-box;padding-top: 6px;" @click="selectGoods">
            <div><van-icon name="bag-o"  size="20"/></div>
            选择商品
        </div>
        <div style="width:1px;height:30px;background:#FFF"></div>
        <div style="flex:5;height: 50px;box-sizing: border-box;padding-top: 6px;" @click="save">
            <div>
                <van-icon name="success" size="20"/>
            </div>
            保存
        </div>
        <div style="width:1px;height:30px;background:#FFF"></div>
        <div style="flex:4;height: 50px;background: #ff7907;box-sizing: border-box;padding-top: 6px;border-bottom-right-radius: 10px;" @click="closeModle">
            <div><van-icon name="revoke" size="20"/></div>
            返回
        </div>
    </div>
    <edit-good-msg ref="editMsg" @close="closeEdit"/>
    <select-goods ref="selGood" @close="closeModel"></select-goods>
    <select-merchant ref="selectMerchantPick" orgType="1" title="选择组织机构" @change="changeMerchant"></select-merchant>
  </div>
</template>

<script>
import { Toast  } from 'vant';

import detailsTable from './detailsTable';
import selectGoods from './selectGoods';
import editGoodMsg from './editGoodMsg';
export default {
    components:{
        'detali-table':detailsTable,
        'select-goods':selectGoods,
        'edit-good-msg':editGoodMsg
    },
    data() {
        return {
            form: {},
            details: [],
            active: 0,
            showBatchNoModel: false,
            state: 1,
            isShow: false,
            showPreOrderModel: false,
            moreKey: {},
            typeList: [],
            orderAmountAccuracy:'',
            priceSetting: '',
            planappoint: '',
            plantype: '',
            planladder: '',
            showShare:false,
            editGood:false,
            submitLoading:false,
            hasEdit:'',
            options: [
                { name: '微信', icon: 'wechat' },
                { name: '复制链接', icon: 'link' },
            ],
            plandiscount: ''
        }
    },
    created(){
        this.$request.get("purchaseOrder/create",{id:this.$route.query.orderId}).then(data=>{
            this.form=data.content.storeOutInOrder
            this.details=data.content.detailList?data.content.detailList:[]
            this.priceSetting=data.content.priceSetting
            this.orderAmountAccuracy=data.content.orderAmountAccuracy
        })
    },
    methods:{
        selectGoods(){
            if(!this.form.merchantId){
                Toast("请选择组织机构")
                return;
            }
            this.$refs.selGood.open(this.form.merchantId)
        },
        /**
         * 关闭选择商品
         */
        closeModel(item){
            if(item){
                let newIndex=-1
                let hasGood = this.details.find((res,index)=>{
                    if(res.goodsId == item.goodsId){
                        newIndex=index
                        return true
                    }
                })
                this.editGood = false
                if(hasGood){
                    setTimeout(res=>{
                        if(item){
                            this.openEdit(item,newIndex)
                        }
                    },100)
                }else{
                    setTimeout(res=>{
                        if(item){
                            this.openEdit(item)
                        }
                    },100)
                }
            }
        },
        /**
         * 关闭编辑商品
         */
        closeEdit(item){
            if(item){
                switch (this.priceSetting) {
                case "NEW_PURCHASE_PRICE":
                    item.priceYuan = item.newPurchasePrice
                    ? item.newPurchasePrice
                    : item.purchasePrice;
                    break;
                case "STOCK_COST":
                    item.priceYuan = item.cost
                    ? item.cost
                    : item.purchasePrice;
                    break;
                case "GOODS_FUTURE_PRICE":
                    item.priceYuan = item.purchasePrice;
                    break;
                default:
                    break;
                }
                item.amountYuan=item.priceYuan*item.count
                item.amountYuan=item.amountYuan.toFixed(this.orderAmountAccuracy)
                if(this.editGood && this.hasEdit>0){
                    this.details[this.hasEdit] = item
                }else{
                    this.details.push(item)
                }
            }
            this.hasEdit = -1
        },
        openEdit(item,index=-1){
            this.editGood = true
            this.hasEdit = index
            this.$refs.editMsg.open(item);
        },
        changeMerchant(item){
            console.log(item)
            this.$set(this.form,"merchantId",item.id)
            this.$set(this.form,"merchantName",item.name)
        },
        onSelect (option){
            this.showShare = false;
        },
        changeTab(name, title) {
            this.active=name
        },
        goBack(){
            this.router.go(-1)
        },
        shareLink(){
            this.showShare=true
        },
        wxshare () {
            this.$request.getApi("index/wxJsInit?accessKey=" + window.localStorage.getItem("accessKey")+"&dir="+encodeURIComponent(window.location.href.split('#')[0])+"&appId="+window.localStorage.getItem("appId")).then(data => {
                if(data.status==200){
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: data.content.appId, // 必填，公众号的唯一标识
                        timestamp: data.content.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.content.nonceStr, // 必填，生成签名的随机串
                        signature: data.content.signature, // 必填，签名
                        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
                    });
                    wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
                        wx.updateTimelineShareData({
                            title: '订货单', // 分享标题
                            link: window.location.href, 
                            // (link)分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致**这里不需要做urlencode编码,一开始我就是做了编码一直分享的是本页面链接
                            imgUrl: imgurls, // 分享图标
                            success: function () {
                            // 设置成功
                            }
                        })
                    })
                    wx.error(function (res) {
                        alert('分享失败')
                    })
                }else if(data.status==40100){
                    localStorage.removeItem("token")
                }
            }).catch(err => {
                if (err.status == 40100) {
                    localStorage.removeItem("token")
                }
            })
        },
        save() {
            if(this.submitLoading){
                return;
            }
            this.submitLoading=true
            this.$request.postJSON("purchaseOrder/create", {...this.form,detailList:this.details}).then(res=>{
                this.submitLoading = false
                if(res.status == 200){
                    this.$orderAuditLoading.show(res.content,(res)=>{
                        if(res.code==2){
                            this.form=res.order
                        }
                    })
                }else{
                    Toast(res.message)
                }
            }).catch(res=>{
                this.submitLoading = false
                Toast(res.message)
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>

.add-ord-title{
    font-size: 16px;
    padding-bottom:5px;
    border-bottom:1px solid #ccc
}

.add-ord-desc{
    font-size:15px;
}
.order-price{
    color:#F56C6C;
    font-weight: 600
}


.add-tabs{
    font-size:15px !important;
    font-weight:700
}



.model-bg {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1;
    height: calc(100vh - 65px);
    width: 50vw;
    background-color: rgba(0, 0, 0, 0.78);
}
.sub-btn{
    width: 60px;
    color:#FFF;
    background-color: rgb(73, 53, 174);
    text-align: center;
    height: 60px;
    margin-left: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 30px;
    bottom: 40px;
    z-index: 10;
}
.btn-share{
    position: fixed;
    right: 12px;
    bottom: 22px;
    width: 50px;
    background-color: #4C37B6;
    color: #FFF;
    text-align: center;
    z-index: 10;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/supplierOrder/detail.vue